import BusinessIcon from '@mui/icons-material/Business';
import LockIcon from '@mui/icons-material/Lock';
import PersonIcon from '@mui/icons-material/Person';
import React from 'react';

export function entityIcon(type: string | undefined): React.ReactElement {
  if (type === 'INDIVIDUAL' || type === 'JOINT') return <PersonIcon sx={{ fontSize: 14 }} />;
  if (type === 'SMSF' || type === 'SUPERFUND') return <LockIcon sx={{ fontSize: 14 }} />;
  return <BusinessIcon sx={{ fontSize: 14 }} />;
}
